import { jsxs, jsx } from 'react/jsx-runtime';
import { ReactComponent } from '@sketch/icons/chevron-horizontal-12';
import { Item, Divider } from './Crumb.styles.js';

const Crumb = ({ children, isActive, showAllInMobile, isLink, isCompleted, number, }) => {
    return (jsxs(Item, Object.assign({ "$number": number, "$isActive": isActive, "$isCompleted": isCompleted, "$showAllInMobile": showAllInMobile, "$isLink": isLink }, { children: [children, jsx(Divider, { children: jsx(ReactComponent, { height: "16px" }) })] })));
};

export { Crumb };
